var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3644 1.67786C12.2478 1.97109 12.9414 2.66654 13.6381 3.64365C14.3326 4.61753 15.1 5.97541 16.0892 7.72578L16.128 7.7945C17.1174 9.54511 17.8848 10.9029 18.363 12.0041C18.8435 13.1106 19.0829 14.0659 18.8919 14.9838C18.6996 15.9079 18.2255 16.7483 17.535 17.3834C16.8462 18.017 15.9083 18.2844 14.7274 18.4127C13.5531 18.5404 12.017 18.5404 10.04 18.5404H9.95877C7.9817 18.5404 6.44563 18.5404 5.27137 18.4127C4.09041 18.2844 3.15251 18.017 2.4637 17.3834C1.7732 16.7483 1.29908 15.9079 1.10681 14.9838C0.91585 14.0659 1.15518 13.1106 1.63572 12.0041C2.11395 10.9029 2.88131 9.54511 3.87067 7.79449L3.9095 7.72578C4.89869 5.97541 5.66608 4.61753 6.36058 3.64365C7.05738 2.66654 7.75097 1.97109 8.63435 1.67786C9.52135 1.38342 10.4774 1.38342 11.3644 1.67786ZM9.9956 13.332C9.53743 13.332 9.16602 13.7051 9.16602 14.1654C9.16602 14.6256 9.53743 14.9987 10.0031 14.9987C10.4613 14.9987 10.8327 14.6256 10.8327 14.1654C10.8327 13.7051 10.4613 13.332 9.9956 13.332ZM9.99935 6.66536C9.5391 6.66536 9.16602 7.03846 9.16602 7.4987V10.832C9.16602 11.2923 9.5391 11.6654 9.99935 11.6654C10.4596 11.6654 10.8327 11.2923 10.8327 10.832V7.4987C10.8327 7.03846 10.4596 6.66536 9.99935 6.66536Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert02);
export default __webpack_public_path__ + "static/media/alert-02.aa957b72857440b6df72803b92f7dd5c.svg";
export { ForwardRef as ReactComponent };